/**
 * Cosmic Urgency Timer Engine
 * Synchronized Midnight Reset Logic
 */

class CosmicUrgencyTimer {
  constructor() {
    this.hoursEl = document.getElementById('timer-hours');
    this.minsEl = document.getElementById('timer-mins');
    this.secsEl = document.getElementById('timer-secs');

    if (!this.hoursEl || !this.minsEl || !this.secsEl) return;

    this.init();
  }

  init() {
    this.update();
    setInterval(() => this.update(), 1000);
  }

  update() {
    const now = new Date();
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0); // Next midnight

    const diff = midnight - now; // Time remaining in ms

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const mins = Math.floor((diff / (1000 * 60)) % 60);
    const secs = Math.floor((diff / 1000) % 60);

    // Update DOM with leading zeros
    this.hoursEl.textContent = String(hours).padStart(2, '0');
    this.minsEl.textContent = String(mins).padStart(2, '0');
    this.secsEl.textContent = String(secs).padStart(2, '0');
  }
}

// Global initialization
document.addEventListener('DOMContentLoaded', () => {
  window.cosmicUrgencyInstance = new CosmicUrgencyTimer();
});
